/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Badge_FailedInputs */

const en_directory_submit_badge_failed = /** @type {(inputs: Directory_Submit_Badge_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No badge found on that page yet.`)
};

const zh_directory_submit_badge_failed = /** @type {(inputs: Directory_Submit_Badge_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该页面暂未检测到徽章。`)
};

/**
* | output |
* | --- |
* | "No badge found on that page yet." |
*
* @param {Directory_Submit_Badge_FailedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_badge_failed = /** @type {((inputs?: Directory_Submit_Badge_FailedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Badge_FailedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_badge_failed(inputs)
	return zh_directory_submit_badge_failed(inputs)
});
export { directory_submit_badge_failed as "directory.submit.badge_failed" }